import React, { useState } from 'react'
import { openAppOrStore } from '../../../config'
import { isInAppBrowser } from '../../../pages/NextLaunchPage'

const DISMISS_KEY = 'not-show-download-app-banner'

/**
 * Top "smart app banner" shown across the web app, inviting users to open /
 * install the native app. Complements the existing bottom-sheet in LoginPage
 * (both can show). User-tap only — no auto-redirect — so if the OS/browser
 * can't hand off to the app, the user simply stays on the web.
 */
const DownloadAppBanner: React.FC = () => {
  const [visible, setVisible] = useState(
    () => localStorage.getItem(DISMISS_KEY) !== 'true',
  )
  const [inAppWarning, setInAppWarning] = useState(false)

  if (!visible) return null

  const handleOpen = () => {
    // In-app browsers (FB/LINE/IG) silently block store/app hand-off; guide the
    // user to a real browser instead of doing nothing.
    if (isInAppBrowser()) {
      setInAppWarning(true)
      return
    }
    // Open the native app by scheme/package; falls back to the store if the
    // app isn't installed.
    openAppOrStore()
  }

  const handleClose = () => setVisible(false)

  return (
    <div className="sticky top-0 z-50 w-full">
      <div className="flex items-center gap-2 px-3 py-2 bg-primary">
        <button
          type="button"
          aria-label="ปิด"
          className="flex items-center justify-center w-6 h-6 text-white/70"
          onClick={handleClose}
        >
          <span className="text-lg leading-none">&times;</span>
        </button>
        <img
          src="/washxpress-icon.png"
          alt="WashXpress"
          className="object-contain w-9 h-9 rounded-lg bg-white/10"
        />
        <div className="flex flex-col flex-1 min-w-0 leading-tight">
          <span className="text-sm font-semibold text-white truncate">
            WashXpress
          </span>
          <span className="text-xs truncate text-white/80">
            ใช้งานสะดวกกว่าในแอป
          </span>
        </div>
        <button
          type="button"
          className="px-4 py-1.5 text-sm font-semibold rounded-full bg-white text-primary whitespace-nowrap"
          onClick={handleOpen}
        >
          เปิดแอป
        </button>
      </div>
      {inAppWarning && (
        <div className="px-3 py-2 text-xs text-center text-white bg-danger">
          กรุณาแตะเมนู (•••) แล้วเลือก “เปิดในเบราว์เซอร์” เพื่อเปิดแอป
        </div>
      )}
    </div>
  )
}

export default DownloadAppBanner
